module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Reply-all-225d67ffc4068ba04e8e8f29571cb228.svg";